import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SupplierChargesInformationComponent } from './components/telephony/supplier-charges-information/supplier-charges-information.component';
import { SupplierClosedJobsComponent } from './components/telephony/supplier-closed-jobs/supplier-closed-jobs.component';
import { SupplierWatchedJobsComponent } from './components/telephony/supplier-watched-jobs/supplier-watched-jobs.component';
import { OrganisationSelectorComponent } from './components/telephony/organisation-selector/organisation-selector.component';
import { TableModule } from 'primeng/table';
import { VmeCommonModule } from './vme-common.module';
import { VmeDirectivesModule } from './vme-directives.module';
import { VmePipesModule } from './vme-pipes.module';
import { InteractionsComponent } from './components/interactions/interactions.component';
import { LatestInteractionComponent } from './components/telephony/latest-interaction/latest-interaction.component';
import { InteractionsJobSelectorComponent } from './components/interactions/interaction-job-selector/interaction-job-selector.component';
import { TelephonyControlComponent } from './components/telephony/telephony-control/telephony-control.component';
import { AddNumberToOrganisationComponent } from './components/telephony/add-number-to-organisation/add-number-to-organisation.component';
import { AddNumberOrganisationSearchComponent } from './components/telephony/add-number-to-organisation/add-number-organisation-search.component';
import { AddNumberSelectUserOrgComponent } from './components/telephony/add-number-to-organisation/add-number-select-user-org.component';
import { AddNumberJobSearchComponent } from './components/telephony/add-number-to-organisation/add-number-job-search.component';
import { JobsInformationListComponent } from './components/telephony/jobs-information-list/jobs-information-list.component';
import { TaskInformationCardComponent } from './components/telephony/task-information-card/task-information-card.component';
import { SupplierProfileAllJobsComponent } from './components/telephony/supplier-profile-all-jobs/supplier-profile-all-jobs.component';
import { CustomerProfileAllJobsComponent } from './components/telephony/customer-profile/customer-profile-all-jobs/customer-profile-all-jobs.component';
import { VirtualScrollerModule } from 'primeng';
import { VMEComponentsModule } from './vme-components.module';
import { TelephonyControlTaskTableComponent } from './components/telephony/telephony-control/telephony-control-task-table.component';
import { CallInfoBoxComponent } from './components/telephony/telephony-control/call-info-box/call-info-box.component';

const components = [
  SupplierChargesInformationComponent,
  SupplierClosedJobsComponent,
  SupplierWatchedJobsComponent,
  OrganisationSelectorComponent,
  InteractionsComponent,
  InteractionsJobSelectorComponent,
  LatestInteractionComponent,
  TelephonyControlComponent,
  TelephonyControlTaskTableComponent,
  AddNumberToOrganisationComponent,
  AddNumberOrganisationSearchComponent,
  AddNumberSelectUserOrgComponent,
  AddNumberJobSearchComponent,
  JobsInformationListComponent,
  TaskInformationCardComponent,
  SupplierProfileAllJobsComponent,
  CustomerProfileAllJobsComponent,
];

/**
 * Shared Module (Components)
 * todo: this isn't just components it forwards the directives module and the AGM module.
 */
@NgModule({
  imports: [
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    TableModule,
    VirtualScrollerModule,
    VMEComponentsModule,
    CallInfoBoxComponent,
  ],
  declarations: [...components],
  exports: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // todo: check, this might need tob e in other modules now
})
export class TelephonyComponentsModule {}
